import { SearchTerm } from './SearchTerm';

const SiteCodeSearch: SearchTerm[] = [
    {
        heading: "Code",
        accessor: "code",
        searchOnName: "siteCode",
        translationKey: "code"
    },
    // {
    //     heading: "Fixed Address",
    //     accessor: "fixedAddress",
    //     searchOnName: "devFixedaddr",
    // },
    // {
    //     heading: "IP Address",
    //     accessor: "ipAddress",
    //     searchOnName: "devIpaddress",
    // },
    // {
    //     heading: "Type",
    //     accessor: "type",
    //     searchOnName: "unitType.utDescOriginal",
    // },
    // {
    //     heading: "Site",
    //     accessor: "site",
    //     searchOnName: "site.siteName",
    // },
    // {
    //     heading: "Controller",
    //     accessor: "controller",
    //     searchOnName: "terminal.controller.deviceImprox.devName",
    // },
    // {
    //     heading: "Door",
    //     accessor: "door",
    //     searchOnName: "terminal.location.locName",
    // },
];

export default SiteCodeSearch;
